import {
  ContactsOutlined,
  DollarOutlined,
  ForkOutlined,
  NodeIndexOutlined,
  SettingOutlined,
} from '@ant-design/icons';
// @todo Winner - Not sure if this is correct?
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { UserRole } from './models/User';
import AdminCarriersPage from './pages/AdminCarriersPage';
import AdminModesPage from './pages/AdminModesPage';
import AdminPasswordPage from './pages/AdminPasswordPage';
import AdminRateClassesPage from './pages/AdminRateClassesPage';
import AdminRatesPage from './pages/AdminRatesPage';
import AdminShipTypesPage from './pages/AdminShipTypesPage';
import AdminTerminalsPage from './pages/AdminTerminalsPage';
import AdminUploadPage from './pages/AdminUploadPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminVehicleTypesPage from './pages/AdminVehicleTypesPage';
import CarrierInsurancePage from './pages/CarrierInsurancePage';
import CarrierModesPage from './pages/CarrierModesPage';
import CarrierNotesPage from './pages/CarrierNotesPage';
import CarrierOptionsPage from './pages/CarrierOptionsPage';
import CarrierPasswordPage from './pages/CarrierPasswordPage';
import CarrierProfilePage from './pages/CarrierProfilePage';
import CarrierRateClassesPage from './pages/CarrierRateClassesPage';
import CarrierRatesPage from './pages/CarrierRatesPage';
import CarrierRatingsPage from './pages/CarrierRatingsPage';
import CarrierTerminalsPage from './pages/CarrierTerminalsPage';
import CarrierUploadPage from './pages/CarrierUploadPage';
import CarrierVehicleTypesPage from './pages/CarrierVehicleTypesPage';
import ContactsPage from './pages/ContactsPage';
import PathBuilderPage from './pages/PathBuilderPage';
import ShortestPathSearchPage from './pages/ShortestPathSearchPage';
import TripsPage from './pages/TripsPage';

/*
export interface IPageProps {
  routes: IPageRoute[];
}

export interface IPageRoute extends LayoutRoute {
  component: React.FC<IPageProps>;
  menuIndex?: number;
}
*/

export const allRoutes = {
  [UserRole.SUPER_ADMIN]: [
    {
      component: AdminRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      key: 'rates',
      menuIndex: 0,
      name: 'Rates',
      path: '/',
      routes: [
        {
          component: AdminRatesPage,
          exact: true,
          icon: <DollarOutlined />,
          key: 'view-rates',
          name: 'View Rates',
          path: '/',
        },
        {
          component: AdminUploadPage,
          exact: true,
          key: 'upload-rates',
          name: 'Upload Rates',
          path: '/upload',
        },
      ],
    },
    {
      icon: <ForkOutlined />,
      key: 'paths',
      menuIndex: 0,
      name: 'Paths',
      path: '/search',
      routes: [
        {
          component: ShortestPathSearchPage,
          exact: true,
          key: 'search-path',
          name: 'Search Path',
          path: '/search',
        },
        {
          component: PathBuilderPage,
          exact: true,
          key: 'path-builder',
          name: 'Path Builder',
          path: '/pathBuilder',
        },
      ],
    },
    {
      component: TripsPage,
      exact: true,
      icon: <NodeIndexOutlined />,
      menuIndex: 0,
      name: 'Trips',
      path: '/trips',
    },
    {
      component: ContactsPage,
      exact: true,
      icon: <ContactsOutlined />,
      menuIndex: 0,
      name: 'Contacts',
      path: '/contacts',
    },
    {
      icon: <SettingOutlined />,
      key: 'settings',
      menuIndex: 0,
      name: 'Settings',
      path: '/settings',
      routes: [
        {
          component: AdminUsersPage,
          exact: true,
          key: 'users',
          name: 'Users',
          path: '/settings/users',
        },
        {
          component: AdminCarriersPage,
          exact: true,
          key: 'carriers',
          name: 'Carriers',
          path: '/settings/carriers',
        },
        {
          component: AdminTerminalsPage,
          exact: true,
          key: 'terminals',
          name: 'Terminals',
          path: '/settings/terminals',
        },
        {
          component: AdminModesPage,
          exact: true,
          key: 'modes',
          name: 'Modes of Transport',
          path: '/settings/modes',
        },
        {
          component: AdminRateClassesPage,
          exact: true,
          key: 'rate-classes',
          name: 'Rate Classes',
          path: '/settings/rate-classes',
        },
        {
          component: AdminVehicleTypesPage,
          exact: true,
          key: 'vehicles',
          name: 'Vehicle Types',
          path: '/settings/vehicle-types',
        },
        {
          component: AdminShipTypesPage,
          exact: true,
          key: 'shipTypes',
          name: 'Ship Types',
          path: '/settings/ship-types',
        },
        {
          component: AdminPasswordPage,
          exact: true,
          key: 'password',
          name: 'Update Password',
          path: '/settings/password',
        },
      ],
    },
    {
      component: CarrierRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      key: 'rates',
      menuIndex: 1,
      name: 'Rates',
      path: '/carrier/:carrierId/',
    },
    {
      icon: <SettingOutlined />,
      key: 'settings',
      menuIndex: 1,
      name: 'Settings',
      path: '/carrier/:carrierId/settings',
      routes: [
        {
          component: CarrierProfilePage,
          exact: true,
          key: 'profile',
          name: 'Profile',
          path: '/carrier/:carrierId/settings/profile',
        },
        {
          component: CarrierModesPage,
          exact: true,
          key: 'modes',
          name: 'Modes of Transport',
          path: '/carrier/:carrierId/settings/modes',
        },
        {
          component: CarrierRateClassesPage,
          exact: true,
          key: 'rate-classes',
          name: 'Rate Classes',
          path: '/carrier/:carrierId/settings/rate-classes',
        },
        {
          component: CarrierVehicleTypesPage,
          exact: true,
          key: 'vehicles',
          name: 'Vehicle Types',
          path: '/carrier/:carrierId/settings/vehicle-types',
        },
        {
          component: CarrierOptionsPage,
          exact: true,
          key: 'options',
          name: 'Options',
          path: '/carrier/:carrierId/settings/options',
        },
        {
          component: CarrierTerminalsPage,
          exact: true,
          key: 'terminals',
          name: 'Terminals Serviced',
          path: '/carrier/:carrierId/settings/terminals',
        },
        {
          component: CarrierInsurancePage,
          exact: true,
          key: 'insurance',
          name: 'Insurance',
          path: '/carrier/:carrierId/settings/insurance',
        },
        {
          component: CarrierRatingsPage,
          exact: true,
          key: 'ratings',
          name: 'Ratings',
          path: '/carrier/:carrierId/settings/ratings',
        },
        {
          component: CarrierNotesPage,
          exact: true,
          key: 'notes',
          name: 'Notes',
          path: '/carrier/:carrierId/settings/notes',
        },
      ],
    },
  ],
  [UserRole.ADMIN]: [
    {
      component: AdminRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      key: 'rates',
      menuIndex: 0,
      name: 'Rates',
      path: '/',
      routes: [
        {
          component: AdminRatesPage,
          exact: true,
          icon: <DollarOutlined />,
          key: 'view-rates',
          name: 'View Rates',
          path: '/',
        },
        {
          component: AdminUploadPage,
          exact: true,
          key: 'upload-rates',
          name: 'Upload Rates',
          path: '/upload',
        },
      ],
    },
    {
      component: CarrierRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      key: 'rates',
      menuIndex: 1,
      name: 'Rates',
      path: '/carrier/:carrierId/',
    },
    {
      icon: <SettingOutlined />,
      key: 'settings',
      menuIndex: 1,
      name: 'Settings',
      path: '/carrier/:carrierId/settings',
      routes: [
        {
          component: CarrierProfilePage,
          exact: true,
          key: 'profile',
          name: 'Profile',
          path: '/carrier/:carrierId/settings/profile',
        },
        {
          component: CarrierModesPage,
          exact: true,
          key: 'modes',
          name: 'Modes of Transport',
          path: '/carrier/:carrierId/settings/modes',
        },
        {
          component: CarrierRateClassesPage,
          exact: true,
          key: 'rate-classes',
          name: 'Rate Classes',
          path: '/carrier/:carrierId/settings/rate-classes',
        },
        {
          component: CarrierVehicleTypesPage,
          exact: true,
          key: 'vehicles',
          name: 'Vehicle Types',
          path: '/carrier/:carrierId/settings/vehicle-types',
        },
        {
          component: CarrierOptionsPage,
          exact: true,
          key: 'options',
          name: 'Options',
          path: '/carrier/:carrierId/settings/options',
        },
        {
          component: CarrierTerminalsPage,
          exact: true,
          key: 'terminals',
          name: 'Terminals Serviced',
          path: '/carrier/:carrierId/settings/terminals',
        },
        {
          component: CarrierInsurancePage,
          exact: true,
          key: 'insurance',
          name: 'Insurance',
          path: '/carrier/:carrierId/settings/insurance',
        },
        {
          component: CarrierRatingsPage,
          exact: true,
          key: 'ratings',
          name: 'Ratings',
          path: '/carrier/:carrierId/settings/ratings',
        },
        {
          component: CarrierNotesPage,
          exact: true,
          key: 'notes',
          name: 'Notes',
          path: '/carrier/:carrierId/settings/notes',
        },
      ],
    },
  ],
  [UserRole.CARRIER]: [
    {
      component: CarrierRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      key: 'rates',
      menuIndex: 0,
      name: 'Rates',
      path: '/',
      routes: [
        {
          component: CarrierRatesPage,
          exact: true,
          icon: <DollarOutlined />,
          key: 'view-rates',
          name: 'View Rates',
          path: '/',
        },
        {
          component: CarrierUploadPage,
          exact: true,
          key: 'upload-rates',
          name: 'Upload Rates',
          path: '/upload',
        },
      ],
    },
    {
      icon: <SettingOutlined />,
      key: 'settings',
      menuIndex: 0,
      name: 'Settings',
      path: '/settings',
      routes: [
        {
          component: CarrierProfilePage,
          exact: true,
          key: 'profile',
          name: 'Profile',
          path: '/settings/profile',
        },
        {
          component: CarrierModesPage,
          exact: true,
          key: 'modes',
          name: 'Modes of Transport',
          path: '/settings/modes',
        },
        {
          component: CarrierRateClassesPage,
          exact: true,
          key: 'rate-classes',
          name: 'Rate Classes',
          path: '/settings/rate-classes',
        },
        {
          component: CarrierVehicleTypesPage,
          exact: true,
          key: 'vehicles',
          name: 'Vehicle Types',
          path: '/settings/vehicle-types',
        },
        {
          component: CarrierOptionsPage,
          exact: true,
          key: 'options',
          name: 'Options',
          path: '/settings/options',
        },
        {
          component: CarrierTerminalsPage,
          exact: true,
          key: 'terminals',
          name: 'Terminals Serviced',
          path: '/settings/terminals',
        },
        {
          component: CarrierInsurancePage,
          exact: true,
          key: 'insurance',
          name: 'Insurance',
          path: '/settings/insurance',
        },
        {
          component: CarrierPasswordPage,
          exact: true,
          key: 'user',
          name: 'Update Password',
          path: '/settings/password',
        },
      ],
    },
  ],
  [UserRole.CUSTOMER]: [
    {
      component: CarrierRatesPage,
      exact: true,
      icon: <DollarOutlined />,
      menuIndex: 0,
      name: 'Rates',
      path: '/',
    },
  ],
};

/*
interface IProps {
  routes: IPageRoute[];
}
*/

const flattenRoutes = (routes) => {
  const flattened = [];
  routes.forEach((route) => {
    if (route.component && route.path) {
      flattened.push(route);
    }
    if (route.routes) {
      route.routes.forEach((subRoute) => {
        if (subRoute.component && subRoute.path) {
          flattened.push(subRoute);
        }
      });
    }
  });
  return flattened;
};

const AppRoutes = ({ routes }) => {
  const flatRoutes = flattenRoutes(routes);
  return (
    <Switch>
      {flatRoutes.map((route) => (
        <Route
          key={route.path}
          exact={route.exact}
          path={route.path}
          render={() => <route.component routes={routes} />}
        />
      ))}
    </Switch>
  );
};

export default AppRoutes;
